import { useState } from 'react';

export default function useCanvasDrawingToolsOpen() {
  const [isCanvasDrawingToolsOpen, setCanvasDrawingToolsOpen] = useState<boolean>(true);
  return [isCanvasDrawingToolsOpen, setCanvasDrawingToolsOpen] as const;
}
